import { motion } from 'framer-motion';
import { ChartBarIcon, HomeIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';

const stats = [
  { 
    value: '$500K+', 
    label: 'Total Real Estate AUM',
    icon: CurrencyDollarIcon,
  },
  { 
    value: '4', 
    label: 'Properties',
    icon: HomeIcon,
  },
  { 
    value: '11.66%', 
    label: 'Rental Income Yield',
    icon: ChartBarIcon,
  },
];

export default function StatsBar() {
  return (
    <section className="-mt-20 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="bg-white rounded-lg shadow-lg p-6 text-center">
                <stat.icon className="w-8 h-8 text-secondary mx-auto mb-4" />
                <div className="text-3xl font-bold text-primary mb-2">
                  {stat.value}
                </div>
                <div className="text-gray-600">
                  {stat.label}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}